export const blockIconsHouseholdStylerNew = (
	<span className='material-symbols-outlined'>styler</span>
);
